// services/vesselService.js

import { clearUser } from "@store/auth/userSlice";
import {
	LoadingYahclick,
	setClearVessel,
	setDailyClientCountData,
	setGraphTelemetry,
	setkitHistoryData,
	setLoadingDailyClientCount,
	setLoadingFortigate,
	setLoadingkitHistory,
	setLoadingPeplink,
	setLoadingVesselDetails,
	setLoadingVesselDetailsStarlink,
	setLoadingVesselKits,
	setLoadingVesssels,
	setPeplinkCellular,
	setPeplinkQuality,
	setPeplinkSubscription,
	setPeplinkWan,
	setPeplinkWan2,
	setPingHighLatency,
	setPingHighLatencyYahclick,
	setPingHighLatencyYahclickNG,
	setSelectedKit,
	setSelectedKitLoading,
	setSelectedKitName,
	setSelectedVessel,
	setSTARLINKCorporate,
	setSTARLINKWAN1,
	setSTARLINKWAN2,
	setSTARLINKWelfare,
	setStarlinkAlerts,
	setStarlinkTelemetry,
	setStarlinkUsage,
	setVesselDetails,
	setVesselKits,
	setVesselsData,
	setWansStatus,
	setYahclickBandwidth,
	setYahclickBandwidthNG,
} from "@store/modules/vesselsSlice";
import { validCombinations } from "@utils/telemetry";
import axios from "axios";

const handleUnauthorized = (dispatch, navigate) => {
	dispatch(clearUser());
	navigate("/login");
};

export const fetchVessels = async (
	token,
	dispatch,
	navigate,
	page,
	perPage,
	paginate,
	searchTerms,
	column = "",
	order = "",
	signal,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: {
			paginate: paginate,
			page: page,
			per_page: perPage,
			name: searchTerms?.siteName || "",
			selected: searchTerms?.selected || [],
			// starlinkKit: searchTerms?.kitSerialNumber || "",
			starlinkKit: searchTerms?.kitNumber || "",
			serialNumberKit: searchTerms?.serialNumber || "",
			client_id: searchTerms?.clientId || "",
			sim_card: searchTerms?.simCard || "",
			san_number: searchTerms?.sanNumber || "",
			activation: searchTerms?.activation,
			company: searchTerms?.company_id,
			column: column || "",
			order_type: order || "",
			client: searchTerms?.client,
			search: searchTerms?.search,
			businessUnit: searchTerms?.businessUnit,
			status: searchTerms.status ?? undefined,
		},
		signal: signal,
	};
	try {
		const response = await axios.get(`${import.meta.env.VITE_API_BACKEND}api/vessels`, config);
		let data;

		if (response.data.data.length === 0) {
			data = {
				data: response.data.data,
				totalItems: 0,
				page: 1,
				perPage: 10,
			};
		} else {
			data = {
				data: response.data.data,
				totalItems: response.data.total,
				page: page,
				perPage: perPage,
			};
		}
		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching vessels data:", error);
		}
	}
};
export const fetchVessel = async (token, id, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}`,
			config,
		);
		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching vessel data:", error);
			throw error;
		}
	}
};

export const fetchStarlinkTelemetryUsage = async (
	token,
	id,
	kit_number,
	usage_this_month,
	usage_previous_month,
	device_id,
	service_line_number,
	dispatch,
	navigate,
) => {
	dispatch(setLoadingVesselDetailsStarlink(true));
	try {
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}/usage`,
			config,
		);

		const data = response.data.content;

		await dispatch(
			setStarlinkUsage({
				starlinkId: id,
				kit_numberr: kit_number,
				service_line_number: service_line_number,
				usage_this_month,
				usage_previous_month,
				data: data,
			}),
		);
		dispatch(setLoadingVesselDetailsStarlink(false));
		// fetchStarlinkTelemetry(
		//   token,
		//   id,
		//   device_id,
		//   kit_number,
		//   dispatch,
		//   navigate
		// );
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching Starlink usage data:", error);
		}
		dispatch(setLoadingVesselDetailsStarlink(false));
	}
};

export const fetchStarlinkTelemetry = async (
	token,
	id,
	device_id,
	kit_number,
	dispatch,
	navigate,
) => {
	try {
		await Promise.all(
			validCombinations.map(async (combination) => {
				const { type, label, options } = combination;
				const { database, collection } = options["3h"];

				const config = {
					headers: {
						Authorization: `Bearer ${token}`,
					},
					params: {
						select_database: database,
						select_collection: collection,
					},
				};
				const response = await axios.get(
					`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}/telemetry`,
					config,
				);
				const data = response.data.metric[0];

				await dispatch(
					setStarlinkTelemetry({
						starlinkId: id,
						type,
						label,
						kit_number,
						option: "3h",
						device_id,
						data,
					}),
				);
			}),
		);
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching Starlink telemetry data:", error);
		}
	}
};

export const fetchGraphTelemetry = async (
	token,
	id,
	range,
	type,
	device_id,
	dispatch,
	navigate,
) => {
	try {
		const combination = validCombinations.find((comb) => comb.type === type);

		if (!combination) {
			console.error(`Invalid type: ${type}`);
			return;
		}
		const { database, collection } = combination.options[range];
		if (!database || !collection) {
			throw new Error(`Invalid range: ${range}`);
		}
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params: {
				select_database: database,
				select_collection: collection,
			},
		};
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}/telemetry`,
			config,
		);
		const data = response.data.metric[0];

		dispatch(setGraphTelemetry({ id: id, type, data }));
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching Starlink telemetry data:", error);
		}
	}
};

export const contactSupport = async (token, data, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/contact-support`,
			data,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response && error.response.status === 400) {
			return { status: 400, data: error.response.data };
		} else {
			console.error("Error contacting support:", error);
		}
	}
};
export const fetchStarlinkAlerts = async (token, id, dispatch, navigate) => {
	try {
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/starlinks-alerts`,
			config,
		);
		const data = response.data;
		await dispatch(
			setStarlinkAlerts({
				data,
			}),
		);
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching Starlink telemetry data:", error);
		}
	}
};

export const fetchDataVessels = async (
	dispatch,
	token,
	navigate,
	page,
	perPage,
	paginate,
	searchTerms,
	column = "",
	order_type = "",
	signal = null,
) => {
	dispatch(setLoadingVesssels(true));
	dispatch(setClearVessel());
	try {
		const data = await fetchVessels(
			token,
			dispatch,
			navigate,
			page,
			perPage,
			paginate,
			searchTerms,
			column,
			order_type,
			signal,
		);
		if (data) dispatch(setVesselsData(data));
	} catch (error) {
		console.error("Error fetching data:", error);
	} finally {
		dispatch(setLoadingVesssels(false));
	}
};

export const fetchvesselItemwithredirect = async (
	id,
	name,
	token,
	dispatch,
	navigate,
	url,
	redirect = true,
) => {
	await dispatch(setSelectedVessel({ id, name }));
	await dispatch(setLoadingVesselDetails(true));
	redirect && navigate(url);
	try {
		const data = await fetchVessel(token, id, dispatch, navigate);
		dispatch(setVesselDetails(data));
	} catch (error) {
		console.error("Error fetching data:", error);
	} finally {
		dispatch(setLoadingVesselDetails(false));
	}
};

export const fetchVesselById = async ({ id, name, token, dispatch, navigate }) => {
	try {
		dispatch(setSelectedVessel({ id, name }));
		dispatch(setLoadingVesselDetails(true));
		const data = await fetchVessel(token, id, dispatch, navigate);
		dispatch(setVesselDetails(data));
	} catch (e) {
		throw new Error(e.message);
	} finally {
		dispatch(setLoadingVesselDetails(false));
	}
};

export const fetchStarlinkDetails = async (id, name, token, dispatch, navigate, url) => {
	if (name) dispatch(setSelectedKitName({ id, name }));
	// await dispatch(setSelectedKitLoading(true));
	if (url) navigate(url);
	try {
		const data = await fetchKitStarlink(token, id, dispatch, navigate);
		if (!name) dispatch(setSelectedKitName({ id, name: data.kit_number }));
		dispatch(setSelectedKit(data));
	} catch (error) {
		console.error("Error fetching data:", error);
	} finally {
		dispatch(setSelectedKitLoading(false));
	}
};

export const fetchKitDetailsPage = async (id, token, dispatch, navigate) => {
	try {
		dispatch(setSelectedKitLoading(true));
		const data = await fetchKitStarlink(token, id, dispatch, navigate);
		dispatch(setSelectedKitName({ id, name: data.kit_number }));
		dispatch(setSelectedKit(data));
	} catch (error) {
		throw new Error(error.message);
	} finally {
		dispatch(setSelectedKitLoading(false));
	}
};

export const fetchVesselKits = async (
	id,
	dispatch,
	token,
	navigate,
	page,
	perPage,
	searchTerms,
) => {
	dispatch(setLoadingVesselKits(true));
	try {
		const data = await getVesselKits(id, token, dispatch, navigate, page, perPage, searchTerms);
		dispatch(setVesselKits(data));
	} catch (error) {
		console.error("Error fetching data:", error);
	} finally {
		dispatch(setLoadingVesselKits(false));
	}
};

export const getVesselKits = async (id, token, dispatch, navigate, page, perPage, searchTerms) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: {
			page: page,
			per_page: perPage,
			kit_number: searchTerms?.kitSerialNumber,
			SerialNumberKit: searchTerms?.serialNumber,
			san_number: searchTerms?.sanNumber,
			sim_card: searchTerms?.simCard,
			search: searchTerms?.search,
			...(searchTerms?.filter !== undefined &&
				(parseInt(searchTerms.filter) === 0 || parseInt(searchTerms.filter) === 1) && {
					status: parseInt(searchTerms.filter),
				}),
			paginate: 1,
		},
	};
	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/kits`,
			config,
		);

		let data;
		if (response.data.data.length === 0) {
			data = {
				data: response.data.data,
				totalItems: 0,
				page: 1,
				perPage: 10,
			};
		} else {
			data = {
				data: response.data.data,
				totalItems: response.data.total,
				page: page,
				perPage: perPage,
			};
		}
		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching vessels data:", error);
		}
	}
};

export const fetchKitStarlink = async (token, id, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}`,
			config,
		);
		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching vessels data:", error);
			throw error;
		}
	}
};

export const setOptinPermanent = async (
	selectedKit,
	selectedOption,
	optInValue,
	token,
	dispatch,
	navigate,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	const payload = {
		vessel_starlink_id: selectedKit,
		type: selectedOption,
		...(selectedOption === "WITH_CREDIT_LIMIT" && { opt_in_value: optInValue }),
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/starlink-credit-limits/permanent/handle`,
			payload,
			config,
		);

		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching stocks data:", error);
		}
	}
};

export const setOptinCurrentMonth = async (
	selectedKit,
	selectedOption,
	optInValue,
	initialValue,
	token,
	dispatch,
	navigate,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	if (selectedOption === "OPT_OUT") {
		const payload = {
			vessel_starlink_id: selectedKit,
		};

		try {
			const response = await axios.post(
				`${import.meta.env.VITE_API_BACKEND}api/starlink-credit-limits/optout`,
				payload,
				config,
			);
			return { status: response.status, data: response.data };
		} catch (error) {
			if (error.response && error.response.status === 401) {
				handleUnauthorized(dispatch, navigate);
			} else {
				console.error("Error fetching stocks data:", error);
			}
		}
	} else if (selectedOption === "UNLIMITED" || selectedOption === "WITH_CREDIT_LIMIT") {
		const payload = {
			vessel_starlink_id: selectedKit,
			opt_in_value: selectedOption === "WITH_CREDIT_LIMIT" ? optInValue : 0,
		};

		try {
			let url;
			if (initialValue === "OPT_OUT") {
				url = "api/starlink-credit-limits/optin";
			} else {
				url = "api/starlink-credit-limits/optin/edit";
			}
			const response = await axios.post(
				`${import.meta.env.VITE_API_BACKEND}${url}`,
				payload,
				config,
			);
			return { status: response.status, data: response.data };
		} catch (error) {
			if (error.response && error.response.status === 401) {
				handleUnauthorized(dispatch, navigate);
			} else {
				console.error("Error fetching stocks data:", error);
			}
		}
	}
};

export const setHandleCreditLimit = async (formData, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/starlink-credit-limits/handle`,
			formData,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				handleUnauthorized(dispatch, navigate);
				return null;
			}

			if (error.response.status === 422) {
				return { status: 422, errors: error.response.data.errors };
			}

			return {
				status: error.response.status,
				message: error.response.data?.message || "An error occurred",
			};
		} else {
			console.error("Error handle credit limit:", error);
			return null;
		}
	}
};
export const setHandleSubscriptionPolicy = async (payload, id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	};

	try {
		const response = await axios.put(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}/handle-block-options`,
			payload,
			config,
		);

		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching stocks data:", error);
		}
	}
};
export const fetchPeplinkGraph = async (
	token,
	id,
	hours,
	start_date,
	end_date,
	type,
	title,
	dispatch,
	navigate,
) => {
	try {
		const now = new Date();
		const endOfToday = new Date();
		endOfToday.setHours(23, 59, 59, 999);

		const startOfYesterday = new Date();
		startOfYesterday.setDate(startOfYesterday.getDate() - 1);
		startOfYesterday.setHours(0, 0, 0, 0);

		const start = start_date
			? Math.floor(new Date(start_date).getTime() / 1000)
			: Math.floor(startOfYesterday.getTime() / 1000);

		const end = end_date
			? Math.floor(new Date(end_date).getTime() / 1000)
			: Math.floor(now.getTime() / 1000);

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params: {
				type: type,

				// Only ONE of these modes goes in the request — never both.
				...(hours
					? { hours: Number(hours) }
					: {
							start_date: start,
							end_date: end,
						}),
			},
		};

		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/peplink/charts`,
			config,
		);

		const data = response.data;
		switch (type) {
			case "Wan":
				await dispatch(
					setPeplinkWan({
						VesselId: id,
						hours: hours,
						start_date: start_date,
						end_date: end_date,
						type: title,
						data: data,
						stats: data.stats,
					}),
				);
				await dispatch(setLoadingPeplink(false));

				break;

			case "Wan2":
				await dispatch(
					setPeplinkWan2({
						VesselId: id,
						hours: hours,
						start_date: start_date,
						end_date: end_date,
						type: title,
						data: data,
						stats: data.stats,
					}),
				);
				await dispatch(setLoadingPeplink(false));
				break;

			case "Cellular":
				await dispatch(
					setPeplinkCellular({
						VesselId: id,
						hours: hours,
						start_date: start_date,
						end_date: end_date,
						type: title,
						data: data,
						stats: data.stats,
					}),
				);
				await dispatch(setLoadingPeplink(false));
				break;

			case "Quality":
				await dispatch(
					setPeplinkQuality({
						VesselId: id,
						hours: hours,
						start_date: start_date,
						end_date: end_date,
						type: title,
						data: data,
					}),
				);
				await dispatch(setLoadingPeplink(false));
				break;

			case "Status":
				await dispatch(
					setWansStatus({
						VesselId: id,
						hours: hours,
						start_date: start_date,
						end_date: end_date,
						type: title,
						data: data,
					}),
				);
				await dispatch(setLoadingPeplink(false));
				break;
		}
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error(`Error fetching ${title} data:`, error);
		}
		dispatch(setLoadingPeplink(false));
	}
};

export const setActivationRequest = async (
	selectedKit,
	effective_date,
	selectedPlan,
	type,
	optin_value,
	selectedType,
	selectedLocation,
	options,
	token,
	dispatch,
	navigate,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	const formattedAddress = selectedLocation
		? ` latitude : ${selectedLocation.latitude}, logitude :${selectedLocation.longitude}`
		: "";

	const payload = {
		effective: effective_date,
		plan: selectedPlan,
		type: type,
		...(type === "OPT-in" && { optin_value: optin_value }),
		...(selectedType === "fixe" && { address: formattedAddress }),
		...(options != "" && { options: options }),
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/starlink/${selectedKit}/activate`,
			payload,
			config,
		);

		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching stocks data:", error);
		}
		return { status: error.response.status, data: error.response.data };
	}
};

export const setDeactivationRequest = async (selectedKit, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/starlink/${selectedKit}/deactivate`,
			{},
			config,
		);

		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching stocks data:", error);
		}
		return { status: error.response.status, data: error.response.data };
	}
};

export const setCreditLimitAlertsRequest = async (formData, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	};
	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/alerts/handle`,
			formData,
			config,
		);

		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response) {
			console.error("Error response data:", error.response.data);
			console.error("Error response status:", error.response.status);
		} else {
			console.error("Error message:", error.message);
		}

		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching stocks data:", error);
		}
		return { status: error.response?.status, data: error.response?.data };
	}
};

export const setVesselPhotoRequest = async (type, id, formData, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/photo`,
			formData,
			config,
		);
		return response;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				handleUnauthorized(dispatch, navigate);
			} else {
				console.error("API error:", error.response.data);
			}
			return { status: error.response.status, data: error.response.data };
		} else {
			console.error("Network or other error:", error.message);
			return { status: 500, data: { message: "Network or server error" } };
		}
	}
};

export const setVesselDeletePhoto = async (id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	};

	try {
		const response = await axios.delete(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/photo`,
			config,
		);
		return response;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				handleUnauthorized(dispatch, navigate);
			} else {
				console.error("API error:", error.response.data);
			}
			return { status: error.response.status, data: error.response.data };
		} else {
			console.error("Network or other error:", error.message);
			return { status: 500, data: { message: "Network or server error" } };
		}
	}
};
export const getPhotoById = async (photoUrl, token) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
		responseType: "blob",
	};

	try {
		const response = await axios.get(photoUrl, config);

		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response?.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching photo:", error);
			throw new Error("Unable to fetch the photo. Please try again.");
		}
	}
};

export const setEditVessel = async (formData, id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}`,
			formData,
			config,
		);

		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response && error.response.status === 422) {
			return { errors: error.response.data.errors };
		} else {
			console.error("Error fetching stocks data:", error);
		}
		return { status: error.response.status, data: error.response.data };
	}
};

export const setStoreVessel = async (formData, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessels`,
			formData,
			config,
		);

		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response && error.response.status === 422) {
			return { errors: error.response.data.errors };
		} else {
			console.error("Error fetching stocks data:", error);
		}
		return { status: error.response.status, data: error.response.data };
	}
};

export const fetchAllVessels = async (token, dispatch, navigate, searchTerms) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: {
			client: searchTerms?.client,
		},
	};
	try {
		const response = await axios.get(`${import.meta.env.VITE_API_BACKEND}api/vessels`, config);
		let data;

		if (!response.data || response.data.length === 0) {
			data = {
				data: [],
			};
		} else {
			data = {
				data: response.data,
			};
		}
		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching all vessels data:", error);
		}
	}
};

export const fetchAllSubscriptions = async (token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/subscriptions`,
			config,
		);

		let data;

		if (!response.data || response.data.length === 0) {
			data = [];
		} else {
			data = response.data;
		}

		dispatch(setPeplinkSubscription(data));

		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching subscriptions:", error);
		}
	}
};

export const setUpdatePeplinkConfiguration = async (data, id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	try {
		const response = await axios.put(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/smartboxes`,
			data,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching stocks data:", error);
		}
		return { status: error.response.status, data: error.response.data };
	}
};
export const setCreatePeplinkConfiguration = async (data, id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/smartboxes`,
			data,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching stocks data:", error);
		}
		return { status: error.response.status, data: error.response.data };
	}
};

export const setVesselStatus = async (id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/x-www-form-urlencoded",
		},
	};

	const data = new URLSearchParams();
	data.append("state", 1);

	try {
		const response = await axios.put(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/status`,
			data,
			config,
		);

		dispatch(setVesselDetails(response.data.data));
		// dispatch(updateVesselStatusSuccess(response.data));

		// if (navigate) navigate("/success-page");
	} catch (error) {
		console.error("Error updating vessel status:", error);
		// dispatch(updateVesselStatusError(error.message));
	}
};

export const deleteVesselById = async (id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	try {
		const response = await axios.delete(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}`,
			config,
		);
		if (response.status === 200 || response.status === 202 || response.status === 204) {
			return {
				status: "success",
				message: "Vessel deleted successfully.",
			};
		} else {
			return {
				status: "error",
				message: response.data?.message || "An unexpected error occurred.",
			};
		}
	} catch (error) {
		if (error.response) {
			switch (error.response.status) {
				case 401:
					handleUnauthorized(dispatch, navigate);
					break;
				case 404:
					return { status: "not_found", message: "Not found." };
				case 405:
					return {
						status: "method_not_allowed",
						message: "Method Not Allowed",
					};
				case 400:
					return {
						status: "error",
						message: error.response.data?.message || "An error occurred.",
					};
				default:
					return { status: "error", message: "An error occurred." };
			}
		} else {
			return { status: "error", message: "Network error" };
		}
	}
};

export const deleteselectedKit = async (id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	try {
		const response = await axios.delete(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}`,
			config,
		);
		if (response.status === 200 || response.status === 202 || response.status === 204) {
			return {
				status: "success",
				message: "Kit deleted successfully.",
			};
		} else {
			return {
				status: "error",
				message: response.data?.message || "An unexpected error occurred.",
			};
		}
	} catch (error) {
		if (error.response) {
			switch (error.response.status) {
				case 401:
					handleUnauthorized(dispatch, navigate);
					break;
				case 404:
					return { status: "not_found", message: "Not found." };
				case 405:
					return {
						status: "method_not_allowed",
						message: "Method Not Allowed",
					};
				case 400:
					return {
						status: "error",
						message: error.response.data?.message || "An error occurred.",
					};
				default:
					return { status: "error", message: "An error occurred." };
			}
		} else {
			return { status: "error", message: "Network error" };
		}
	}
};

export const setDeletePeplinkConfiguration = async (id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	try {
		const response = await axios.delete(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-smartboxes/${id}`,
			config,
		);
		return { status: response.status, data: response.data }; // Return the correct response
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error delete peplink data:", error);
		}
		return {
			status: error.response?.status || 500,
			data: error.response?.data || {},
		};
	}
};

export const fetchModulesList = async (token, dispatch, navigate, searchTerms) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			Accept: "application/json",
		},
		params: {
			client_id: searchTerms?.client_id,
			company_id: searchTerms?.company_id,
		},
	};
	try {
		const url = `${import.meta.env.VITE_API_BACKEND}api/vessels/modules`;

		const response = await axios.get(url, config);

		let data;
		if (!response.data || response.data.length === 0) {
			data = {
				data: [],
			};
		} else {
			data = {
				data: response.data,
			};
		}
		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching models transactions crud data:", error.response || error);
		}
	}
};

export const editKitdetails = async (token, dispatch, navigate, data, kitId) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	try {
		const response = await axios.put(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${kitId}`,
			data,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response && error.response.status === 422) {
			const responseData = error.response.data;
			const errorMessages = responseData.errors;

			let formattedErrors = "Validation error occurred.";

			if (errorMessages && typeof errorMessages === "object") {
				formattedErrors = Object.entries(errorMessages)
					.map(([key, messages]) => messages.join("\n"))
					.join("\n");
			} else if (responseData.message) {
				formattedErrors = responseData.message;
			}

			return { errors: formattedErrors };
		} else {
			console.error("Error fetching stocks data:", error);
		}
		return { status: error.response.status, data: error.response.data };
	}
};

export const fetchDataSaipem = async (
	dispatch,
	token,
	navigate,
	searchTerms = {},
	distributor_role,
	vessel_id,
	page = 1,
	perPage = 10,
	column = "",
	order = "",
	paginate = true,
	signal,
) => {
	try {
		const endpoint = distributor_role ? "api/scap/usage" : "api/vessels/saipem";

		const baseParams = distributor_role
			? {
					distributor_id: searchTerms?.distributor_id,
					client_name: searchTerms?.clientName,
				}
			: { client_id: searchTerms?.filter, vessel_id: vessel_id };

		const params = {
			...baseParams,
			paginate,
			page,
			per_page: perPage,
			name: searchTerms?.siteName || "",
			search: searchTerms?.siteNameAndKitNumber || "",
			last_month: searchTerms?.last_month ? 1 : 0,
			column,
			order_type: order,
		};

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params,
			signal,
		};

		const response = await axios.get(`${import.meta.env.VITE_API_BACKEND}${endpoint}`, config);

		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching data:", error);
			throw error;
		}
	} finally {
		dispatch(setLoadingVesssels(false));
	}
};

export const fetchDatascapdistr = async (
	dispatch,
	token,
	navigate,
	searchTerms = {},
	distributor_role,
	vessel_id,
	page = 1,
	perPage = 10,
	column = "",
	order = "",
	paginate = true,
) => {
	try {
		const endpoint = "api/vessels/saipem";

		const baseParams = { client_id: searchTerms?.filter, vessel_id: vessel_id };

		const params = {
			...baseParams,
			paginate,
			page,
			per_page: perPage,
			name: searchTerms?.siteName || "",
			search: searchTerms?.siteNameAndKitNumber || "",
			column,
			order_type: order,
			// search:"KIT4E00087494",
		};

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params,
		};

		const response = await axios.get(`${import.meta.env.VITE_API_BACKEND}${endpoint}`, config);

		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching data:", error);
			throw error;
		}
	} finally {
		dispatch(setLoadingVesssels(false));
	}
};

export const fetchDataVesselsDetailsScap = async (
	dispatch,
	token,
	navigate,
	client_id,
	page = 1,
	perPage = 10,
	paginate = true,
	searchTerms = {},
	column = "",
	order = "",
	signal,
) => {
	try {
		const endpoint = "api/scap/details";
		const params = {
			paginate,
			page,
			per_page: perPage,
			client_id,
			search: searchTerms?.siteNameAndKitNumber || "",
			column,
			order_type: order,
		};

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params,
			signal,
		};

		const response = await axios.get(`${import.meta.env.VITE_API_BACKEND}${endpoint}`, config);

		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching vessel details:", error);
			throw error;
		}
	} finally {
		dispatch(setLoadingVesssels(false));
	}
};

export const fetchCyberSecurity = async (token, id, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/report`,
			config,
		);
		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching vessel data:", error);
		}
	}
};

export const fetchOrganizationList = async (token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			Accept: "application/json",
		},
	};
	try {
		const url = `${import.meta.env.VITE_API_BACKEND}api/vessels/peplink/organization`;

		const response = await axios.get(url, config);

		let data;
		if (!response.data || response.data.length === 0) {
			data = {
				data: [],
			};
		} else {
			data = {
				data: response.data,
			};
		}
		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching Organization List:", error.response || error);
		}
	}
};

export const fetchGroupeByOrganization = async (
	token,
	organizationId,
	groupeId,
	dispatch,
	navigate,
	page,
	perPage = 10,
	paginate = 1,
	searchTerms,
	signal,
) => {
	try {
		const url = `${import.meta.env.VITE_API_BACKEND}api/vessels/peplink/group`;

		const response = await axios.get(url, {
			headers: {
				Authorization: `Bearer ${token}`,
				Accept: "application/json",
			},
			signal, // optional for abort
			params: {
				page,
				per_page: perPage,
				paginate,
				organizationId,
				groupeId,
				groupName: searchTerms?.groupName || "",
			},
		});

		return {
			data: response.data?.data || [],
			total: response.data.total,
			page: paginate === 1 ? page : 1,
			perPage: paginate === 1 ? perPage : 10,
		};
	} catch (error) {
		if (error.response?.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching Group by Organization List:", error.response || error);
		}
	}
};

export const fetchRebootTerminal = async (kitId, token, dispatch, navigate) => {
	try {
		const url = `${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${kitId}/reboot`;

		const response = await fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		if (response.status === 401) {
			handleUnauthorized(dispatch, navigate);
			throw new Error("Unauthorized");
		}

		if (!response.ok) {
			const errorData = await response.json().catch(() => null);

			throw new Error(errorData?.message || "Failed to reboot terminal");
		}

		return await response.json();
	} catch (error) {
		console.error("Reboot terminal error:", error);
		throw error;
	}
};
export const fetchSuspendUsuspendTerminal = async (kitId, token, status, dispatch, navigate) => {
	try {
		const url = `${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${kitId}/suspended-restored`;

		const response = await fetch(url, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ type: status === "suspend" ? true : false }),
		});
		if (!response.ok) {
			throw new Error("Failed to status terminal");
		}
		return response.json();
	} catch (error) {
		if (error.response?.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching Group by Organization List:", error.response || error);
		}
	}
};

export const fetchFortigateGraph = async (
	token,
	id,
	hours,
	start_date,
	end_date,
	type,
	title,
	dispatch,
	navigate,
) => {
	try {
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params: {
				type,
				hours,
				start_date,
				end_date,
			},
		};

		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/centreon`,
			config,
		);

		const data = response.data;

		switch (type) {
			case "Ping_High_Latency":
				await dispatch(
					setPingHighLatency({
						VesselId: id,
						hours,
						start_date,
						end_date,
						type: title,
						data,
					}),
				);
				await dispatch(setLoadingFortigate(false));
				break;

			case "STARLINK_Fortigate_Interface_Corporate":
				await dispatch(
					setSTARLINKCorporate({
						VesselId: id,
						hours,
						start_date,
						end_date,
						type: title,
						data,
					}),
				);
				await dispatch(setLoadingFortigate(false));
				break;

			case "STARLINK_Fortigate_Interface_Welfare":
				await dispatch(
					setSTARLINKWelfare({
						VesselId: id,
						hours,
						start_date,
						end_date,
						type: title,
						data,
					}),
				);
				await dispatch(setLoadingFortigate(false));
				break;

			case "STARLINK_Fortigate_Interface_WAN1":
				await dispatch(
					setSTARLINKWAN1({
						VesselId: id,
						hours,
						start_date,
						end_date,
						type: title,
						data,
					}),
				);
				await dispatch(setLoadingFortigate(false));
				break;

			case "STARLINK_Fortigate_Interface_WAN2":
				await dispatch(
					setSTARLINKWAN2({
						VesselId: id,
						hours,
						start_date,
						end_date,
						type: title,
						data,
					}),
				);
				await dispatch(setLoadingFortigate(false));
				break;
		}
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error(`Error fetching ${title} data:`, error);
		}
		dispatch(setLoadingFortigate(false));
	}
};

export const fetchDownloadTelemetry = async (
	token,
	device_id,
	job_name,
	type,
	selectedRange,
	dispatch,
	navigate,
	setShowErrorModal,
) => {
	const typeMap = {
		downlink: "DownlinkThroughput",
		uplink: "UplinkThroughput",
		obstruction: "ObstructionPercentTime",
		pingdrop: "PingDropRateAvg",
		pinglatency: "PingLatencyMsAvg",
		signalobstruction: "SignalQuality",
	};

	const apiType = typeMap[type];
	try {
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				Accept: "application/json",
			},
			responseType: "blob", // important pour les fichiers binaires (CSV)
			params: {
				terminal_id: "ut" + device_id,
				telemetry_endpoint: job_name,
				type: apiType,
				time_range: selectedRange,
			},
		};

		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/prometheuse/export-telemetry`,
			config,
		);

		const blob = new Blob([response.data], { type: "text/csv" });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = "telemetry-export -" + type + "-" + device_id + Date.now() + ".csv"; // tu peux le rendre dynamique si besoin
		document.body.appendChild(a);
		a.click();
		a.remove();
		window.URL.revokeObjectURL(url);
	} catch (error) {
		if (error.response) {
			const { status, data } = error.response;

			if (status === 401) {
				handleUnauthorized(dispatch, navigate);
			} else if (status === 400 || status === 422) {
				// Validation or bad request
				setShowErrorModal(data);
				return { status, data };
			} else if (status === 500) {
				// Internal server error
				return {
					status,
					data: { message: "A server error occurred. Please try again later." },
				};
			} else {
				console.error(`Unhandled API error (${status}):`, data);
				return { status, data };
			}
		} else {
			console.error("Network or unexpected error:", error);
			return {
				status: "network_error",
				data: { message: "Unable to connect to the server." },
			};
		}
	}
};
export const deactivateKit = async (data, id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}/deactivate-request`,
			data,
			config,
		);
		return {
			status: response.status,
			message: response.data?.message,
		};
	} catch (error) {
		if (error.response) {
			const status = error.response.status;

			if (status === 401) {
				handleUnauthorized(dispatch, navigate);
			} else if (status === 422) {
				return { status, errors: error.response.data.errors };
			} else if (status === 400) {
				return {
					status,
					message: error.response.data.message || "Bad request",
					errors: error.response.data.errors || {},
				};
			}
		}

		console.error("Error deactivate kit", error);
		return { status: 500, message: "Internal server error" };
	}
};

export const retryActivation = async (token, id, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	try {
		const response = await axios.put(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlink-activations/${id}/activation-retry`,
			{}, // empty body for PUT
			config,
		);
		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response?.data?.message) {
			// 👇 throw custom error with backend message
			throw new Error(error.response.data.message);
		} else {
			throw new Error("An unknown error occurred while retrying activation.");
		}
	}
};

export const fetchYahclickData = async (token, id, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: { type: "Ping_High_Latency" },
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-yahclicks/${id}/data`,
			config,
		);
		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching vessel-yahclicks data:", error);
		}
	}
};

export const fetchYahclickGraph = async (
	token,
	id,
	hours,
	start_date,
	end_date,
	type,
	title,
	dispatch,
	navigate,
) => {
	try {
		const now = new Date();

		// If "hours" is provided, calculate start time based on it
		const start = hours
			? new Date(now.getTime() - hours * 60 * 60 * 1000)
			: new Date(now.getTime() - 24 * 60 * 60 * 1000);

		const startTimestamp = start_date
			? typeof start_date === "number"
				? start_date // already in seconds
				: Math.floor(new Date(start_date).getTime() / 1000)
			: Math.floor(start.getTime() / 1000);

		const endTimestamp = end_date
			? typeof end_date === "number"
				? end_date
				: Math.floor(new Date(end_date).getTime() / 1000)
			: Math.floor(now.getTime() / 1000);
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params: {
				type,
				hours,
				start_date: startTimestamp || null,
				end_date: endTimestamp || null,
			},
		};

		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-yahclicks/${id}/data`,
			config,
		);

		const data = response.data;

		switch (type) {
			case "Ping_High_Latency":
				dispatch(
					setPingHighLatencyYahclick({
						YahclickId: id,
						hours,
						start_date: startTimestamp || null,
						end_date: endTimestamp || null,
						type: title,
						data,
					}),
				);
				dispatch(LoadingYahclick(false));
				break;

			case "Fortigate_Interface_YahsatLink":
				dispatch(
					setYahclickBandwidth({
						YahclickId: id,
						hours,
						start_date: startTimestamp || null,
						end_date: endTimestamp || null,
						type: title,
						data,
					}),
				);

			default:
				dispatch(LoadingYahclick(false));
				break;
		}
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error(`Error fetching ${title} data:`, error);
		}
		dispatch(LoadingYahclick(false));
	}
};

export const fetchYahclickGraphNG = async (
	token,
	id,
	hours,
	start_date,
	end_date,
	type,
	title,
	dispatch,
	navigate,
) => {
	try {
		const now = new Date();

		const start = hours
			? new Date(now.getTime() - hours * 60 * 60 * 1000)
			: new Date(now.getTime() - 24 * 60 * 60 * 1000);

		const startTimestamp = start_date
			? typeof start_date === "number"
				? start_date // already in seconds
				: Math.floor(new Date(start_date).getTime() / 1000)
			: Math.floor(start.getTime() / 1000);

		const endTimestamp = end_date
			? typeof end_date === "number"
				? end_date
				: Math.floor(new Date(end_date).getTime() / 1000)
			: Math.floor(now.getTime() / 1000);
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params: {
				type,
				hours,
				start_date: startTimestamp || null,
				end_date: endTimestamp || null,
			},
		};

		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-yahclicks/${id}/data`,
			config,
		);

		const data = response.data;

		switch (type) {
			case "Ping_High_Latency":
				dispatch(
					setPingHighLatencyYahclickNG({
						YahclickId: id,
						hours,
						start_date: startTimestamp || null,
						end_date: endTimestamp || null,
						type: title,
						data,
					}),
				);
				dispatch(LoadingYahclick(false));
				break;

			case "Fortigate_Interface_EUTLink":
				dispatch(
					setYahclickBandwidthNG({
						YahclickId: id,
						hours,
						start_date: startTimestamp || null,
						end_date: endTimestamp || null,
						type: title,
						data,
					}),
				);
				dispatch(LoadingYahclick(false));
				break;

			default:
				dispatch(LoadingYahclick(false));
				break;
		}
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error(`Error fetching ${title} data:`, error);
		}
		dispatch(LoadingYahclick(false));
	}
};
export const fetchVouchers = async (
	token,
	vesselId,
	dispatch,
	navigate,
	page = 1,
	perPage = 10,
	searchTerms = {},
	paginate = 1,
	signal = null,
) => {
	const searchValue = searchTerms?.search?.trim() || null;

	const onlineValue =
		searchTerms?.online !== "" && searchTerms?.online !== null && searchTerms?.online !== undefined
			? searchTerms.online
			: null;

	const categoryValue =
		searchTerms?.category !== "" &&
		searchTerms?.category !== null &&
		searchTerms?.category !== undefined
			? searchTerms.category
			: null;
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: {
			vessel: vesselId,
			page,
			per_page: perPage,
			...(searchValue && { search: searchValue }),
			...(onlineValue !== null && { online: onlineValue }),
			...(categoryValue !== null && { category: categoryValue }),
			paginate,
		},
		signal,
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-vouchers`,
			config,
		);

		const apiData = response.data;

		const data =
			!apiData.data || apiData.data.length === 0
				? {
						data: [],
						totalItems: 0,
						page: paginate === 1 ? page : 1,
						perPage: paginate === 1 ? perPage : 10,
					}
				: {
						data: apiData.data,
						totalItems: apiData.total,
						page: paginate === 1 ? apiData.current_page : 1,
						perPage: paginate === 1 ? perPage : 10,
					};

		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching vouchers:", error);
		}
	}
};

export const fetchVesselUsers = async (
	token,
	vesselId,
	dispatch,
	navigate,
	page = 1,
	perPage = 10,
	searchTerms = {},
	paginate = 1,
	signal = null,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: {
			vessel: vesselId,
			page,
			per_page: perPage,
			search: typeof searchTerms === "string" ? searchTerms : (searchTerms?.search ?? null),
			paginate,
		},
		signal,
	};
	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${vesselId}/get-linked-users`,
			config,
		);

		const apiData = response.data;
		const paginationResponse = apiData.meta;

		const data =
			!apiData.data || apiData.data.length === 0
				? {
						data: [],
						totalItems: 0,
						page: paginate === 1 ? page : 1,
						perPage: paginate === 1 ? perPage : 10,
					}
				: {
						data: apiData.data,
						totalItems: paginationResponse.total,
						page: paginationResponse.current_page,
						perPage: perPage,
					};

		return data;
	} catch (error) {
		if (axios.isCancel(error) || error.name === "CanceledError") {
			return;
		}

		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching vessel users:", error);
		}
	}
};

const ACCOUNT = "FIRST";

export const fetchTelemetryData = async (
	metricType,
	timeRange,
	deviceId,
	accountNumber,
	signal,
) => {
	try {
		const response = await axios.get(`${import.meta.env.VITE_API_TELEMETRY}api/telemetry`, {
			headers: {
				"X-API-KEY": import.meta.env.VITE_API_TELEMETRY_KEY,
			},
			params: {
				query: metricType,
				timeRange: timeRange,
				terminalId: deviceId ?? null,
				account: accountNumber,
			},
			signal,
		});

		return response.data;
	} catch (error) {
		if (error.response) {
			throw new Error(`API request failed: ${error.response.status} ${error.response.statusText}`);
		}

		throw new Error("Network error or server not reachable");
	}
};

export const fetchDailyClientCountForVouchers = async (
	token,
	dispatch,
	id,
	start = null,
	end = null,
	signal = null,
) => {
	try {
		dispatch(setLoadingDailyClientCount(true));
		const today = new Date();

		const formatDate = (date) => date.toLocaleDateString("en-CA");
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params: {
				start: start,
				end: end || formatDate(today),
			},
			signal,
		};

		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/${id}/peplink/daily-client-count`,
			config,
		);

		// Check if response contains data
		const data = response.data.data.data; // Use response.data instead of response

		// Dispatch the result
		dispatch(setDailyClientCountData({ data }));
	} catch (error) {
		dispatch(setLoadingDailyClientCount(false));
		console.error("Error fetching daily client data:", error);
	}
};

export const setDownloadVouchersData = async (
	token,
	dispatch,
	navigate,
	vesselId,
	searchTerms = {},
	signal,
) => {
	const searchValue = searchTerms?.search?.trim() || null;

	const onlineValue =
		searchTerms?.online !== "" && searchTerms?.online !== null && searchTerms?.online !== undefined
			? searchTerms.online
			: null;

	const categoryValue =
		searchTerms?.category !== "" &&
		searchTerms?.category !== null &&
		searchTerms?.category !== undefined
			? searchTerms.category
			: null;
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		responseType: "blob",
		params: {
			vessel: vesselId,
			...(searchValue && { search: searchValue }),
			...(onlineValue !== null && { online: onlineValue }),
			...(categoryValue !== null && { category: categoryValue }),
		},
		signal,
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-vouchers/download`,
			config,
		);

		const blob = new Blob([response.data]);
		const url = window.URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = url;

		const contentDisposition = response.headers["content-disposition"];
		let fileName = "vouchers.xlsx";
		if (contentDisposition && contentDisposition.includes("filename=")) {
			fileName = contentDisposition.split("filename=")[1].replace(/['"]/g, "").trim();
		}

		link.setAttribute("download", fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();

		window.URL.revokeObjectURL(url);
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error downloading file:", error);
		}
	}
};

export const setDownloadVesselsData = async (
	token,
	searchTerms = {},

	signal,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		responseType: "blob",
		params: {
			company: searchTerms?.company_id,
			client_id: searchTerms?.clientId,
			search: searchTerms?.search,
			businessUnit: searchTerms?.businessUnit,
			status: searchTerms.status ?? undefined,
		},
		signal,
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessels/download`,
			config,
		);

		const blob = new Blob([response.data]);
		const url = window.URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = url;

		const contentDisposition = response.headers["content-disposition"];
		let fileName = "vessels.xlsx";
		if (contentDisposition && contentDisposition.includes("filename=")) {
			fileName = contentDisposition.split("filename=")[1].replace(/['"]/g, "").trim();
		}

		link.setAttribute("download", fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();

		window.URL.revokeObjectURL(url);
	} catch (error) {
		if (error.response) {
			try {
				// Convert blob → text → JSON
				const text = await error.response.data.text();
				const data = JSON.parse(text);

				throw new Error(data.message || "Failed to download vessels");
			} catch (parseError) {
				// fallback if parsing fails
				throw new Error("Failed to download vessels");
			}
		}

		// network / unexpected error
		throw new Error(error.message || "Network error");
	}
};

export const fetchIncreaseAllowance = async (vesselId, token) => {
	try {
		const url = `${import.meta.env.VITE_API_BACKEND}api/vessels/${vesselId}/increase-allowance`;

		const response = await fetch(url, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		let data;
		try {
			data = await response.json();
		} catch {
			data = null;
		}

		if (!response.ok) {
			const message =
				data?.message || data?.error || `Request failed with status ${response.status}`;

			throw new Error(message);
		}

		return data;
	} catch (error) {
		console.error("Error increase allowance:", error);
		throw error;
	}
};

export const fetchKitHistoryData = async (
	kitId,
	token,
	dispatch,
	page,
	perPage,
	from = null,
	to = null,
	signal = null,
) => {
	try {
		dispatch(setLoadingkitHistory(true));

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params: {
				page,
				per_page: perPage,
				paginate: 1,
				from: from,
				to: to,
			},
			signal,
		};

		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${kitId}/get-requests`,
			config,
		);

		const responseData = response.data;
		const paginationResponse = response.data.meta;

		dispatch(
			setkitHistoryData({
				data: responseData.data || [],
				totalItems: paginationResponse.total || 0,
				page: paginationResponse.current_page || 1,
				perPage: paginationResponse.per_page || 10,
			}),
		);
	} catch (error) {
		if (error.name !== "CanceledError") {
			console.error("Error fetching kit history:", error);
		}
	} finally {
		dispatch(setLoadingkitHistory(false));
	}
};

export const fetchVoucherTokens = async (
	token,
	TokenId,
	dispatch,
	navigate,
	page = 1,
	perPage = 10,
	searchTerms = {},
	paginate = 1,
	signal = null,
) => {
	const searchValue = searchTerms?.search?.trim() || null;

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: {
			vesselCaptivePortal: TokenId,
			page,
			per_page: perPage,
			...(searchValue && { search: searchValue }),
			paginate,
		},
		signal,
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/captive-portal-tokens`,
			config,
		);

		const apiData = response.data;

		const data =
			!apiData.data || apiData.data.length === 0
				? {
						data: [],
						totalItems: 0,
						page: paginate === 1 ? page : 1,
						perPage: paginate === 1 ? perPage : 10,
					}
				: {
						data: apiData.data,
						totalItems: apiData.total,
						page: paginate === 1 ? apiData.current_page : 1,
						perPage: paginate === 1 ? perPage : 10,
					};

		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching vouchers:", error);
		}
	}
};

export const SetNewVoucherToken = async (CaptiveId, token, data) => {
	const url = `${import.meta.env.VITE_API_BACKEND}api/captive-portal-tokens/${CaptiveId}`;

	try {
		const response = await fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		});

		let responseData = null;

		try {
			responseData = await response.json();
		} catch {
			responseData = null;
		}

		// HANDLE 401
		if (response.status === 401) {
			handleUnauthorized(dispatch, navigate);
			return;
		}

		if (!response.ok) {
			throw responseData || { message: `Request failed with status ${response.status}` };
		}

		return responseData;
	} catch (error) {
		console.error("Error adding voucher token:", error);
		throw error;
	}
};

export const setDownloadVoucherTokensData = async (
	token,
	dispatch,
	navigate,
	idCaptivePortal,
	searchTerms = {},
	signal,
) => {
	const searchValue = searchTerms?.search?.trim() || null;

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		responseType: "blob",
		params: {
			...(searchValue && { search: searchValue }),
		},
		signal,
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/captive-portal-tokens/${idCaptivePortal}/download`,
			config,
		);

		const blob = new Blob([response.data]);
		const url = window.URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = url;

		const contentDisposition = response.headers["content-disposition"];
		let fileName = "voucher_tokens.xlsx";
		if (contentDisposition && contentDisposition.includes("filename=")) {
			fileName = contentDisposition.split("filename=")[1].replace(/['"]/g, "").trim();
		}

		link.setAttribute("download", fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();

		window.URL.revokeObjectURL(url);
	} catch (error) {
		if (error.response) {
			try {
				// Convert blob → text → JSON
				const text = await error.response.data.text();
				const data = JSON.parse(text);

				throw new Error(data.message || "Failed to download vessels");
			} catch (parseError) {
				// fallback if parsing fails
				throw new Error("Failed to download vessels");
			}
		}

		// network / unexpected error
		throw new Error(error.message || "Network error");
	}
};

export const SetNewConfigRouter = async (kitId, token, data) => {
	const url = `${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${kitId}/router-config-request`;

	const response = await fetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(data),
	});

	const responseData = await response.json().catch(() => null);

	if (!response.ok) {
		throw responseData;
	}

	return responseData;
};

export const SetUpdateConfigRouter = async (kitId, token, data) => {
	const url = `${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${kitId}/update-router-config`;

	const response = await fetch(url, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(data),
	});

	const responseData = await response.json().catch(() => null);

	if (!response.ok) {
		throw responseData;
	}

	return responseData;
};

export const setConfirmRouterConfig = async (kitId, token, dispatch, navigate) => {
	try {
		const url = `${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${kitId}/sync-router-config`;

		const response = await fetch(url, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		if (response.status === 401) {
			handleUnauthorized(dispatch, navigate);
			throw new Error("Unauthorized");
		}

		if (!response.ok) {
			const errorData = await response.json().catch(() => null);

			throw new Error(errorData?.message || "Failed to confirm router config throught starlink");
		}

		return await response.json();
	} catch (error) {
		console.error("Router config throught starlink error:", error);
		throw error;
	}
};
